/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as AboutRouteImport } from "./routes/about"
import { Route as BlogRouteImport } from "./routes/blog"
import { Route as ContactRouteImport } from "./routes/contact"
import { Route as ExperienceRouteImport } from "./routes/experience"
import { Route as ProjectsRouteImport } from "./routes/projects"
import { Route as ResumeRouteImport } from "./routes/resume"
import { Route as BlogSlugRouteImport } from "./routes/blog_.$slug"
import { Route as ProjectsSlugRouteImport } from "./routes/projects_.$slug"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: "/about",
  path: "/about",
  getParentRoute: () => rootRouteImport,
} as any)
const BlogRoute = BlogRouteImport.update({
  id: "/blog",
  path: "/blog",
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: "/contact",
  path: "/contact",
  getParentRoute: () => rootRouteImport,
} as any)
const ExperienceRoute = ExperienceRouteImport.update({
  id: "/experience",
  path: "/experience",
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRoute = ProjectsRouteImport.update({
  id: "/projects",
  path: "/projects",
  getParentRoute: () => rootRouteImport,
} as any)
const ResumeRoute = ResumeRouteImport.update({
  id: "/resume",
  path: "/resume",
  getParentRoute: () => rootRouteImport,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: "/blog_/$slug",
  path: "/blog/$slug",
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsSlugRoute = ProjectsSlugRouteImport.update({
  id: "/projects_/$slug",
  path: "/projects/$slug",
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/about": typeof AboutRoute
  "/blog": typeof BlogRoute
  "/contact": typeof ContactRoute
  "/experience": typeof ExperienceRoute
  "/projects": typeof ProjectsRoute
  "/resume": typeof ResumeRoute
  "/blog/$slug": typeof BlogSlugRoute
  "/projects/$slug": typeof ProjectsSlugRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/about": typeof AboutRoute
  "/blog": typeof BlogRoute
  "/contact": typeof ContactRoute
  "/experience": typeof ExperienceRoute
  "/projects": typeof ProjectsRoute
  "/resume": typeof ResumeRoute
  "/blog/$slug": typeof BlogSlugRoute
  "/projects/$slug": typeof ProjectsSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/about": typeof AboutRoute
  "/blog": typeof BlogRoute
  "/contact": typeof ContactRoute
  "/experience": typeof ExperienceRoute
  "/projects": typeof ProjectsRoute
  "/resume": typeof ResumeRoute
  "/blog_/$slug": typeof BlogSlugRoute
  "/projects_/$slug": typeof ProjectsSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/about"
    | "/blog"
    | "/contact"
    | "/experience"
    | "/projects"
    | "/resume"
    | "/blog/$slug"
    | "/projects/$slug"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/about"
    | "/blog"
    | "/contact"
    | "/experience"
    | "/projects"
    | "/resume"
    | "/blog/$slug"
    | "/projects/$slug"
  id:
    | "__root__"
    | "/"
    | "/about"
    | "/blog"
    | "/contact"
    | "/experience"
    | "/projects"
    | "/resume"
    | "/blog_/$slug"
    | "/projects_/$slug"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  BlogRoute: typeof BlogRoute
  ContactRoute: typeof ContactRoute
  ExperienceRoute: typeof ExperienceRoute
  ProjectsRoute: typeof ProjectsRoute
  ResumeRoute: typeof ResumeRoute
  BlogSlugRoute: typeof BlogSlugRoute
  ProjectsSlugRoute: typeof ProjectsSlugRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/about": {
      id: "/about"
      path: "/about"
      fullPath: "/about"
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/blog": {
      id: "/blog"
      path: "/blog"
      fullPath: "/blog"
      preLoaderRoute: typeof BlogRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/contact": {
      id: "/contact"
      path: "/contact"
      fullPath: "/contact"
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/experience": {
      id: "/experience"
      path: "/experience"
      fullPath: "/experience"
      preLoaderRoute: typeof ExperienceRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/projects": {
      id: "/projects"
      path: "/projects"
      fullPath: "/projects"
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/resume": {
      id: "/resume"
      path: "/resume"
      fullPath: "/resume"
      preLoaderRoute: typeof ResumeRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/blog_/$slug": {
      id: "/blog_/$slug"
      path: "/blog/$slug"
      fullPath: "/blog/$slug"
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/projects_/$slug": {
      id: "/projects_/$slug"
      path: "/projects/$slug"
      fullPath: "/projects/$slug"
      preLoaderRoute: typeof ProjectsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  BlogRoute: BlogRoute,
  ContactRoute: ContactRoute,
  ExperienceRoute: ExperienceRoute,
  ProjectsRoute: ProjectsRoute,
  ResumeRoute: ResumeRoute,
  BlogSlugRoute: BlogSlugRoute,
  ProjectsSlugRoute: ProjectsSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
